module.exports = __webpack_public_path__ + "static/media/infinite.d3ed7c47.svg";